import React, { useContext, useState } from "react";
import OwnTabletImg from "../../../assets/images/tablet.png";
import OwnTerminalImg from "../../../assets/images/terminal.webp";
import a11 from "../../../assets/images/a11.png";
import a22 from "../../../assets/images/a22.png";
import a33 from "../../../assets/images/a33.png";
import a44 from "../../../assets/images/a44.png";
import a50 from "../../../assets/images/a50.png";
import a51 from "../../../assets/images/a51.png";
import a52 from "../../../assets/images/a52.png";
import Incrementor from "../components/Incrementor";
import SwitchContext from "../context";
import Computer from "../../../assets/images/mac-uzeli-left1.png";
import ReactSwitch from "react-switch";
// import StandWarning from "../components/StandWarning";
// import StandWarningDialog from "../components/StandWarningDialog";

const SixthPage = () => {
  const {
    openAdditionalValues,
    setAdditionalValues,
    equipmentsFilledFromOrder,
    equipmentPrice,
    isOutOfStock,
    isUpperLimitReached,
    openValues,
  } = useContext(SwitchContext);
  // console.log({
  //   price: equipmentPrice.AriesStand,
  //   value: openAdditionalValues,
  // });
  const [kiozzkWarning, setKiozzkWarning] = useState("");
  const [smartCheckoutWarning, setSmartCheckoutWarning] = useState("");
  const [computerWarning, setComputerWarning] = useState("");
  const [receiptPrinterWarning, setReceiptPrinterWarning] = useState("");
  const [smallCashDrawerWarning, setSmallCashDrawerWarning] = useState("");
  const [bigCashDrawerWarning, setBigCashDrawerWarning] = useState("");
  // const [ariesStandWarning, setAriesStandWarning] = useState("");

  // const [standWarning, setStandWarning] = useState(false);

  // const closeStandWarning = () => {
  //   setStandWarning(false);
  // };

  // useEffect(() => {
  //   const hasCheckoutTerminal =
  //     openValues?.SmartCheckout > 0 || openAdditionalValues?.SmartCheckout > 0;

  //   const hasAriesStand = openAdditionalValues?.AriesStand > 0;
  //   // console.log({
  //   //   nextButtonClicked,
  //   //   openAdditionalValues,
  //   //   openValues,
  //   // });
  //   // if (!hasAriesStand && hasCheckoutTerminal) {
  //   //   if (isOutOfStock("Aries Stand")) {
  //   //     setAriesStandWarning("Currently out of stock");
  //   //     setTimeout(() => {
  //   //       setAriesStandWarning("");
  //   //     }, 2000);
  //   //     return;
  //   //   } else if (isUpperLimitReached("Aries Stand")) {
  //   //     setAriesStandWarning("Maximum quantity reached");
  //   //     setTimeout(() => {
  //   //       setAriesStandWarning("");
  //   //     }, 2000);
  //   //     return;
  //   //   }
  //   //   incrementValue("AriesStand");
  //   //   setStandWarning(false);
  //   // }
  //   // if (nextButtonClicked && hasCheckoutTerminal && !hasAriesStand) {
  //   //   setStandWarning(true);
  //   //   // setCurrentPage(6);
  //   // }
  // }, [
  //   nextButtonClicked,
  //   openValues?.SmartCheckout,
  //   openAdditionalValues?.SmartCheckout,
  //   openAdditionalValues?.AriesStand,
  // ]);
  const incrementValue = (text) => {
    window.GZAnalytics &&
      window.GZAnalytics.customLog({
        name: "Cart Items",
        eventtype: "changed",
        payload: {
          [text]: openAdditionalValues[text] + 1,
        },
      });
    setAdditionalValues({
      ...openAdditionalValues,
      [text]: openAdditionalValues[text] + 1,
    });
  };

  // const closeStandWarning = () => {};

  const decrementValue = (text) => {
    window.GZAnalytics &&
      window.GZAnalytics.customLog({
        name: "Cart Items",
        eventtype: "changed",
        payload: {
          [text]: openAdditionalValues[text] - 1,
        },
      });
    if (openAdditionalValues[text] > 0)
      setAdditionalValues({
        ...openAdditionalValues,
        [text]: openAdditionalValues[text] - 1,
      });
  };

  const toggleValue = (text, value) => {
    window.GZAnalytics &&
      window.GZAnalytics.customLog({
        name: "Cart Items",
        eventtype: "changed",
        payload: {
          [text]: value,
        },
      });
    setAdditionalValues({
      ...openAdditionalValues,
      [text]: value,
    });
  };

  return (
    <div>
      <div className="w-full lg:mr-auto mb-[4rem]">
        <p className="text-xl md:text-3xl capitalize mb-1 font-medium">
          {equipmentsFilledFromOrder
            ? "6. Review Your Equipments"
            : "6. Additional Equipments"}
        </p>
        <div className="pl-0 md:pl-8 text-paragraph">
          <p className="mb-1 leading-relaxed">
            Uzeli supports the use of multiple devices for check-in, POS and
            checkout as needed. If you want additional devices on top of what
            you selected in the previous steps, please add them below.
          </p>
        </div>
      </div>
      <div
        className={`h-full items-center ${
          openAdditionalValues.Kiozzk > 0
            ? "flex bg-[#fbe9c5] my-2"
            : "flex my-2"
        }`}
      >
        <div className="md:w-1/3 ">
          <img
            src={a22}
            alt="Growthzilla Kiozzk Tablet"
            className="mx-auto  my-4 transition-all duration-500 ease-out hover:scale-125"
            style={{ width: "140px", height: "auto" }}
          />
        </div>

        <div className="md:w-1/3 md:my-4 py-2">
          <h5 className="text-lg mb-1">Growthzilla Kiozzk Tablet</h5>
          <p className="text-paragraph text-[15px] ">
            If you want additional check-in kiosks or POS stations, get more
            Kiozzk tablets.
          </p>
        </div>
        <div className="md:w-1/3 md:my-4 py-2">
          <Incrementor
            value={openAdditionalValues.Kiozzk}
            price={equipmentPrice.Kiozzk}
            onIncrease={() => {
              if (isOutOfStock("Growthzilla Kiozzk")) {
                setKiozzkWarning("Currently out of stock");
                setTimeout(() => {
                  setKiozzkWarning("");
                }, 2000);
                return;
              } else if (isUpperLimitReached("Growthzilla Kiozzk")) {
                setKiozzkWarning("Maximum quantity reached");
                setTimeout(() => {
                  setKiozzkWarning("");
                }, 2000);
                return;
              }
              incrementValue("Kiozzk");
            }}
            onDecrease={() => decrementValue("Kiozzk")}
            warning={kiozzkWarning}
          />
        </div>
      </div>

      <div
        className={`h-full items-center ${
          openAdditionalValues.SmartCheckout > 0
            ? "flex bg-[#fbe9c5]  my-2"
            : "flex my-2"
        }`}
      >
        <div className="md:w-1/3 ">
          <img
            src={a11}
            alt=""
            className="mx-auto  my-4 transition-all duration-500 ease-out hover:scale-125"
            style={{ width: "140px", height: "auto" }}
          />
        </div>
        <div className="md:w-1/3 my-4 py-2">
          <h5 className="text-lg mb-1">
            Pax Aries 8 Checkout Terminal with Stand
          </h5>
          <p className="text-paragraph text-[15px]">
            If you want additional client-facing credit card SmartCheckout
            terminal, update the count below.
          </p>
        </div>

        <div className="md:w-1/3 my-4 py-2">
          <Incrementor
            value={openAdditionalValues.SmartCheckout}
            price={equipmentPrice.SmartCheckout}
            onIncrease={() => {
              if (isOutOfStock("Smart Checkout")) {
                setSmartCheckoutWarning("Currently out of stock");
                setTimeout(() => {
                  setSmartCheckoutWarning("");
                }, 2000);
                return;
              } else if (isUpperLimitReached("Smart Checkout")) {
                setSmartCheckoutWarning("Maximum quantity reached");
                setTimeout(() => {
                  setSmartCheckoutWarning("");
                }, 2000);
                return;
              }
              incrementValue("SmartCheckout");
            }}
            onDecrease={() => decrementValue("SmartCheckout")}
            warning={smartCheckoutWarning}
          />
        </div>
      </div>

      <div
        className={`h-full items-center ${
          openAdditionalValues.ReceiptPrinter > 0
            ? "flex bg-[#fbe9c5] my-2"
            : "flex my-2"
        }`}
      >
        <div className="md:w-1/3">
          <img
            src={a33}
            alt=""
            className="mx-auto w-2/5 my-4 transition-all duration-500 ease-out hover:scale-125"
            style={{ width: "140px", height: "auto" }}
          />
        </div>
        <div className="md:w-1/3 my-4 py-2">
          <h5 className="text-lg mb-1">Growthzilla Cloud Receipt Printer</h5>
          <p className="text-paragraph text-[15px]">
            If you want multiple-checkout stations, you may want to add
            additional receipt printers below.
          </p>
        </div>

        <div className="md:w-1/3 my-4 py-2">
          <Incrementor
            value={openAdditionalValues.ReceiptPrinter}
            price={equipmentPrice.ReceiptPrinter}
            onIncrease={() => {
              if (isOutOfStock("Growthzilla Cloud Receipt Printer")) {
                setReceiptPrinterWarning("Currently out of stock");
                setTimeout(() => {
                  setReceiptPrinterWarning("");
                }, 2000);
                return;
              } else if (
                isUpperLimitReached("Growthzilla Cloud Receipt Printer")
              ) {
                setReceiptPrinterWarning("Maximum quantity reached");
                setTimeout(() => {
                  setReceiptPrinterWarning("");
                }, 2000);
                return;
              }
              incrementValue("ReceiptPrinter");
            }}
            onDecrease={() => decrementValue("ReceiptPrinter")}
            warning={receiptPrinterWarning}
          />
        </div>
      </div>

      <div
        className={`h-full items-center ${
          openAdditionalValues.Computer > 0
            ? "flex bg-[#fbe9c5] my-2"
            : "flex my-2"
        }`}
      >
        <div className="md:w-1/3">
          <img
            src={Computer}
            alt=""
            className="mx-auto w-2/5 my-4 transition-all duration-500 ease-out hover:scale-125"
            style={{ width: "140px", height: "auto" }}
          />
        </div>
        <div className="md:w-1/3 my-4 py-2">
          <h5 className="text-lg mb-1">Bring Your Own Desktop</h5>
          <p className="text-paragraph text-[15px]">
            If you want to run Uzeli on additional desktop computers (bring your
            own), increase the count below.
          </p>
        </div>

        <div className="md:w-1/3 my-4 py-2">
          <Incrementor
            value={openAdditionalValues.Computer}
            price={equipmentPrice.Computer}
            onIncrease={() => {
              if (isOutOfStock("Computer")) {
                setComputerWarning("Currently out of stock");
                setTimeout(() => {
                  setComputerWarning("");
                }, 2000);
                return;
              } else if (isUpperLimitReached("Computer")) {
                setComputerWarning("Maximum quantity reached");
                setTimeout(() => {
                  setComputerWarning("");
                }, 2000);
                return;
              }
              incrementValue("Computer");
            }}
            onDecrease={() => decrementValue("Computer")}
            warning={computerWarning}
          />
        </div>
      </div>

      <div
        className={`h-full items-center ${
          openAdditionalValues.CashdrawerSmall > 0
            ? "flex bg-[#fbe9c5] my-2"
            : "flex my-2"
        }`}
      >
        <div className="md:w-1/3">
          <img
            src={a44}
            alt=""
            className="mx-auto w-2/5 my-4 transition-all duration-500 ease-out hover:scale-125"
            style={{ width: "140px", height: "auto" }}
          />
        </div>
        <div className="md:w-1/3 my-4 py-2">
          <h5 className="text-lg mb-1">Small Cash Drawer</h5>
          <p className="text-paragraph text-[15px]">
            If you want multiple-checkout stations taking cash, add receipt
            printers below.
          </p>
        </div>

        <div className="md:w-1/3  my-4 py-2">
          <Incrementor
            value={openAdditionalValues.CashdrawerSmall}
            price={equipmentPrice.CashdrawerSmall}
            onIncrease={() => {
              if (isOutOfStock('Cash Drawer Small(13")')) {
                setSmallCashDrawerWarning("Currently out of stock");
                setTimeout(() => {
                  setSmallCashDrawerWarning("");
                }, 2000);
                return;
              } else if (isUpperLimitReached('Cash Drawer Small(13")')) {
                setSmallCashDrawerWarning("Maximum quantity reached");
                setTimeout(() => {
                  console.log(smallCashDrawerWarning);
                  setSmallCashDrawerWarning("");
                }, 2000);
                return;
              }
              incrementValue("CashdrawerSmall");
            }}
            onDecrease={() => decrementValue("CashdrawerSmall")}
            warning={smallCashDrawerWarning}
          />
        </div>
      </div>

      <div
        className={`h-full items-center ${
          openAdditionalValues.CashdrawerBig > 0
            ? "flex bg-[#fbe9c5] mt-2"
            : "flex mt-2"
        }`}
      >
        <div className="md:w-1/3">
          <img
            src={a44}
            alt=""
            className="mx-auto w-2/5 my-4 transition-all duration-500 ease-out hover:scale-125"
            style={{ width: "140px", height: "auto" }}
          />
        </div>
        <div className="md:w-1/3 my-4 py-2">
          <h5 className="text-lg mb-1">Large Cash Drawer</h5>
          <p className="text-paragraph text-[15px]">
            If you want multiple-checkout stations taking cash, add receipt
            printers below.
          </p>
        </div>
        <div className="md:w-1/3 my-4 py-2">
          <Incrementor
            value={openAdditionalValues.CashdrawerBig}
            price={equipmentPrice.CashdrawerBig}
            onIncrease={() => {
              if (isOutOfStock('Cash Drawer Big(16")')) {
                setBigCashDrawerWarning("Currently out of stock");
                setTimeout(() => {
                  setBigCashDrawerWarning("");
                }, 2000);
                return;
              } else if (isUpperLimitReached('Cash Drawer Big(16")')) {
                setBigCashDrawerWarning("Maximum quantity reached");
                setTimeout(() => {
                  setBigCashDrawerWarning("");
                }, 2000);
                return;
              }
              incrementValue("CashdrawerBig");
            }}
            onDecrease={() => decrementValue("CashdrawerBig")}
            warning={bigCashDrawerWarning}
          />
        </div>
      </div>
      {/* Customer-supplied hardware. Incrementors rather than the on/off switches used
          on pages 1 and 3: there the question is "do you have one?", here it is "how many
          MORE?", and a salon can bring several of its own tablets. Priced at $0 — these are
          recorded so the order reflects the real device count, not to charge for them.
          Note the tablet still affects the plan tier (see useDeviceCounter's PRICING
          DECISION comment); the terminal does not. */}
      <div
        className={`h-full items-center ${
          openAdditionalValues.OwnTablet > 0
            ? "flex bg-[#fbe9c5] my-2"
            : "flex my-2"
        }`}
      >
        <div className="md:w-1/3 ">
          <img
            src={OwnTabletImg}
            alt="Bring your own tablet"
            className="mx-auto my-4 transition-all duration-500 ease-out hover:scale-125"
            style={{ width: "140px", height: "auto" }}
          />
        </div>
        <div className="md:w-1/3 md:my-4 py-2">
          <h5 className="text-lg mb-1">Bring your own tablet</h5>
          <p className="text-paragraph text-[15px] ">
            Already have tablets you want to use for check-in? Add them here.
            There is no hardware charge, but each one counts as a device on your
            plan. Ask your Growthzilla sales partner to confirm they can run
            check-in.
          </p>
        </div>
        <div className="md:w-1/3 md:my-4 py-2">
          <Incrementor
            value={openAdditionalValues.OwnTablet}
            price={equipmentPrice.OwnTablet}
            onIncrease={() => incrementValue("OwnTablet")}
            onDecrease={() => decrementValue("OwnTablet")}
          />
        </div>
      </div>

      <div
        className={`h-full items-center ${
          openAdditionalValues.OwnTerminal > 0
            ? "flex bg-[#fbe9c5] my-2"
            : "flex my-2"
        }`}
      >
        <div className="md:w-1/3 ">
          <img
            src={OwnTerminalImg}
            alt="Bring your own terminal"
            className="mx-auto my-4 transition-all duration-500 ease-out hover:scale-125"
            style={{ width: "140px", height: "auto" }}
          />
        </div>
        <div className="md:w-1/3 md:my-4 py-2">
          <h5 className="text-lg mb-1">Bring your own terminal</h5>
          <p className="text-paragraph text-[15px] ">
            Keep using card terminals you already have. They will not show line
            items or collect tips through Uzeli, so checkout stays a separate
            step on those machines.
          </p>
        </div>
        <div className="md:w-1/3 md:my-4 py-2">
          <Incrementor
            value={openAdditionalValues.OwnTerminal}
            price={equipmentPrice.OwnTerminal}
            onIncrease={() => incrementValue("OwnTerminal")}
            onDecrease={() => decrementValue("OwnTerminal")}
          />
        </div>
      </div>

      <p className="text-xl md:text-3xl capitalize mb-1 font-medium">
        Additional Features
      </p>
      <div
        className={`h-full items-center ${
          openAdditionalValues.MobileApp
            ? "flex bg-[#fbe9c5] my-2"
            : "flex my-2"
        }`}
      >
        <div className="md:w-1/3">
          <img
            src={a50}
            alt=""
            className="mx-auto w-2/5 my-4 transition-all duration-500 ease-out hover:scale-125"
            style={{ width: "140px", height: "auto" }}
          />
        </div>
        <div className="md:w-1/3 my-4 py-2">
          <h5 className="text-lg mb-1">Branded Mobile App</h5>
          <p className="text-paragraph text-[15px]">
            If you want your clients to book appointments, view their history
            and receive your offers from their phone, add your own mobile app
            branded with your business name and logo on iOS and Android.
          </p>
        </div>

        <div className="md:w-1/3 my-4 py-2">
          <div className="flex   justify-center items-center mx-2 text-center">
            <div className="font-bold w-1/2 flex justify-start ml-[12%]">
              ${equipmentPrice.MobileApp}
            </div>

            <ReactSwitch
              onChange={(e) => {
                toggleValue("MobileApp", e);
              }}
              price={equipmentPrice.MobileApp}
              checked={openAdditionalValues.MobileApp}
              checkedIcon={false}
              uncheckedIcon={false}
              disabled={
                openValues.SmartCheckout === 0 &&
                openValues.Computer === 0 &&
                openValues.Kiozzk === 0
              }
            />
          </div>
        </div>
      </div>
      <div
        className={`h-full items-center ${
          openAdditionalValues.Website ? "flex bg-[#fbe9c5] my-2" : "flex my-2"
        }`}
      >
        <div className="md:w-1/3">
          <img
            src={a51}
            alt=""
            className="mx-auto w-2/5 my-4 transition-all duration-500 ease-out hover:scale-125"
            style={{ width: "140px", height: "auto" }}
          />
        </div>
        <div className="md:w-1/3 my-4 py-2">
          <h5 className="text-lg mb-1">Branded Website</h5>
          <p className="text-paragraph text-[15px]">
            If you want a professional web presence for your business, add a
            branded website with online booking built in, so new clients can
            find you and book with you directly.
          </p>
        </div>

        <div className="md:w-1/3 my-4 py-2">
          <div className="flex   justify-center items-center mx-2 text-center">
            <div className="font-bold w-1/2 flex justify-start ml-[12%]">
              ${equipmentPrice.Website}
            </div>
            <ReactSwitch
              onChange={(e) => {
                toggleValue("Website", e);
              }}
              price={equipmentPrice.Website}
              checked={openAdditionalValues.Website}
              checkedIcon={false}
              uncheckedIcon={false}
              disabled={
                openValues.SmartCheckout === 0 &&
                openValues.Computer === 0 &&
                openValues.Kiozzk === 0
              }
            />
          </div>
        </div>
      </div>
      <div
        className={`h-full items-center ${
          openAdditionalValues.EmailMarketing
            ? "flex bg-[#fbe9c5] my-2"
            : "flex my-2"
        }`}
      >
        <div className="md:w-1/3">
          <img
            src={a52}
            alt=""
            className="mx-auto w-2/5 my-4 transition-all duration-500 ease-out hover:scale-125"
            style={{ width: "140px", height: "auto" }}
          />
        </div>
        <div className="md:w-1/3 my-4 py-2">
          <h5 className="text-lg mb-1">Email Marketing</h5>
          <p className="text-paragraph text-[15px]">
            If you want to keep your clients coming back between visits, add
            email marketing to send promotions, announcements and automated
            campaigns to your client list from Uzeli.
          </p>
        </div>

        <div className="md:w-1/3 my-4 py-2">
          <div className="flex   justify-center items-center mx-2 text-center">
            <div className="font-bold w-1/2 flex justify-start ml-[12%]">
              ${equipmentPrice.EmailMarketing}
            </div>
            <ReactSwitch
              onChange={(e) => {
                toggleValue("EmailMarketing", e);
              }}
              price={equipmentPrice.EmailMarketing}
              checked={openAdditionalValues.EmailMarketing}
              checkedIcon={false}
              uncheckedIcon={false}
              disabled={
                openValues.SmartCheckout === 0 &&
                openValues.Computer === 0 &&
                openValues.Kiozzk === 0
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SixthPage;
